import React from 'react';
import {
  Avatar,
  ButtonBase,
  Card,
  CardContent,
  Chip,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';

import { ISubSectionForUser } from '../../../../store/V2/SectionSlice';
import { TP_COLORS } from '../../../../constants';

interface ResourceSectionItemProps {
  orderNumber: number;
  section: ISubSectionForUser;
}

const viewResourceButtonStyles: SxProps = {
  backgroundColor: '#3498DB',
  color: TP_COLORS.white,
  p: '8px',
  borderRadius: '5px',
  fontSize: '12px',
  fontWeight: 600,
};

const containerStyles: SxProps = {
  backgroundColor: 'transparent',
  borderRadius: '10px',
  border: '1px dashed #CBD5E1',
};

const ResourceSectionItem: React.FC<ResourceSectionItemProps> = ({
  orderNumber,
  section,
}) => {
  return (
    <Card elevation={0} sx={containerStyles}>
      <CardContent sx={{ p: '16px' }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" flexGrow={1} mr="15px">
            <Avatar
              sx={{
                width: '36px',
                height: '36px',
                backgroundColor: '#1C9FF7',
                mr: '15px',
              }}
            >
              {orderNumber}
            </Avatar>
            <Stack gap={1}>
              <Chip
                size="small"
                label="Resource"
                color="info"
                sx={{ width: 'fit-content' }}
              />
              <Typography
                variant="subtitle2"
                fontWeight={600}
                className="ellipsis-text one-line"
              >
                {section.curriculum} - {section.quiztopiyaTopicName} -{' '}
                {section.quiztopiyaSubTopicName}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center">
            {section.quiztopiyaResourceUrl ? (
              <ButtonBase
                href={`${process.env.PUBLIC_URL}/${section.quiztopiyaResourceUrl}`}
                target="_blank"
                sx={viewResourceButtonStyles}
              >
                View Resource
              </ButtonBase>
            ) : null}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ResourceSectionItem;
